module.exports = __webpack_public_path__ + "img/height_armhole.53e828c3.png";